import React from 'react';
import { Link } from 'react-router-dom';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

export default function FedtfrysningSeoSection() {
  return (
    <div className="fedtfrysning-seo-section">
      {/* 1. INTRODUKTION & HOVEDBUDSKAB */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-6 reveal-on-scroll">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-sand text-espresso text-[11px] font-semibold uppercase tracking-widest border border-taupe-border">
              <i className="fa-solid fa-snowflake text-accent-brown text-xs" aria-hidden="true" />
              <span>Kontrolleret kulde · Odense SV</span>
            </div>

            <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-semibold text-espresso uppercase tracking-wider leading-[1.2]">
              Fedtfrysning i Odense med en personlig plan
            </h2>

            <div className="pl-4 sm:pl-6 border-l-2 border-accent-brown/70 py-1">
              <p className="text-base sm:text-lg text-taupe font-normal leading-relaxed">
                Overvejer du fedtfrysning i Odense, hjælper vi dig med at afklare, om behandlingen passer til din krop og dit mål. Hos{' '}
                <Link to="/" className="text-espresso font-semibold hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/50 hover:decoration-accent-brown transition-colors">
                  Cryo By Breum
                </Link>{' '}
                får du en personlig vurdering og en rolig behandling med fokus på tryghed, realistiske forventninger og et naturligt resultat. Vi tager imod kunder fra Odense og resten af Fyn.
              </p>
            </div>

            {/* Hurtige overblikspunkter */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-6">
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Målrettet indsats</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Lokal fedtreduktion</span>
                <span className="text-xs text-taupe mt-0.5 block">Genstridige depoter uden kirurgi</span>
              </div>
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Tilgang</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Personlig vurdering</span>
                <span className="text-xs text-taupe mt-0.5 block">Rolig behandling og tryghed</span>
              </div>
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Område</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Odense & resten af Fyn</span>
                <span className="text-xs text-taupe mt-0.5 block">Dalumvej 82, 5250 Odense SV</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. HVAD ER FEDTFRYSNING, OG HVORDAN VIRKER KULDEN */}
      <section className="py-20 lg:py-24 bg-warm-beige border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 reveal-on-scroll">
            <div className="max-w-3xl space-y-3">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Metode & Videnskab</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Hvad er fedtfrysning, og hvordan virker kulden
              </h3>
              <p className="text-base sm:text-lg text-taupe leading-relaxed">
                Fedtfrysning er en kropsbehandling, hvor et afgrænset fedtdepot nedkøles kontrolleret. Kulden påvirker fedtcellerne, hvorefter kroppen gradvist håndterer de påvirkede celler gennem sine naturlige processer. Behandlingen foregår uden kirurgi og er udviklet til lokale områder, som kan være svære at ændre.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
              {/* Kort 1: Fedtreduktion vs. vægttab */}
              <div className="p-8 sm:p-10 bg-cream border border-taupe-border/80 space-y-5 flex flex-col justify-between shadow-xs">
                <div className="space-y-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-bullseye text-lg" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Fedtreduktion vs. vægttab
                  </h4>
                  <p className="text-sm sm:text-base text-taupe leading-relaxed">
                    Når du spørger hvad er fedtfrysning, er det vigtigt at skelne mellem fedtreduktion og vægttab. Metoden er ikke en slankekur og kan ikke erstatte bevægelse eller en balanceret kost. Den er i stedet relevant, når du ønsker at arbejde med kroppens form på et konkret og nøje udvalgt område.
                  </p>
                </div>
                <div className="pt-4 border-t border-taupe-border/50 text-xs text-taupe-light flex items-center gap-2">
                  <i className="fa-solid fa-check text-accent-brown" aria-hidden="true" />
                  <span>Formgivning af specifikke kropszoner</span>
                </div>
              </div>

              {/* Kort 2: Fedtfrysning vs. Whole Body Cryotherapy */}
              <div className="p-8 sm:p-10 bg-cream border border-taupe-border/80 space-y-5 flex flex-col justify-between shadow-xs">
                <div className="space-y-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-temperature-arrow-down text-lg" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Forskellige formål med kulde
                  </h4>
                  <p className="text-sm sm:text-base text-taupe leading-relaxed">
                    Hos Cryo By Breum arbejder vi også med kuldeterapi, men fedtfrysning og whole body cryotherapy har forskellige formål. Ved fedtfrysning rettes kulden mod et lokalt fedtdepot, mens kuldeterapi omfatter kroppen bredere og typisk vælges i forbindelse med velvære og restitution.
                  </p>
                </div>
                <div className="pt-4 border-t border-taupe-border/50 text-xs text-taupe-light flex items-center gap-2">
                  <i className="fa-solid fa-check text-accent-brown" aria-hidden="true" />
                  <span>Præcis lokal kuldeeffekt i det udvalgte depot</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. PROCES OVERBLIK (4 TRIN) */}
      <section className="py-20 lg:py-28 bg-sand-light border-b border-taupe-border/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 reveal-on-scroll">
            <div className="max-w-3xl space-y-4">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Trin For Trin</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Sådan foregår forløbet
              </h3>
              <p className="text-base sm:text-lg text-taupe leading-relaxed">
                Vi lægger vægt på en rolig proces, hvor du er fuldt informeret og tryg gennem hele forløbet.
              </p>
            </div>

            {/* 4 Trin i struktureret opstilling */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Trin 1 */}
              <div className="p-6 bg-cream border border-taupe-border relative flex flex-col justify-between space-y-6 hover:border-espresso/50 transition-colors">
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-sans text-2xl font-bold text-accent-brown tracking-tighter">01</span>
                    <i className="fa-solid fa-comments text-taupe text-sm" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">
                    Forventninger & Mål
                  </h4>
                  <p className="text-sm text-taupe leading-relaxed">
                    Først taler vi om området og det resultat, du håber at opnå
                  </p>
                </div>
                <div className="h-0.5 w-10 bg-accent-brown/30" />
              </div>

              {/* Trin 2 */}
              <div className="p-6 bg-cream border border-taupe-border relative flex flex-col justify-between space-y-6 hover:border-espresso/50 transition-colors">
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-sans text-2xl font-bold text-accent-brown tracking-tighter">02</span>
                    <i className="fa-solid fa-clipboard-user text-taupe text-sm" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">
                    Vurdering & Plan
                  </h4>
                  <p className="text-sm text-taupe leading-relaxed">
                    Derefter vurderer vi, om behandlingen er et relevant valg for dig
                  </p>
                </div>
                <div className="h-0.5 w-10 bg-accent-brown/30" />
              </div>

              {/* Trin 3 */}
              <div className="p-6 bg-cream border border-taupe-border relative flex flex-col justify-between space-y-6 hover:border-espresso/50 transition-colors">
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-sans text-2xl font-bold text-accent-brown tracking-tighter">03</span>
                    <i className="fa-solid fa-snowflake text-taupe text-sm" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">
                    Kontrolleret Nedkøling
                  </h4>
                  <p className="text-sm text-taupe leading-relaxed">
                    Under behandlingen nedkøles det valgte område kontrolleret
                  </p>
                </div>
                <div className="h-0.5 w-10 bg-accent-brown/30" />
              </div>

              {/* Trin 4 */}
              <div className="p-6 bg-cream border border-taupe-border relative flex flex-col justify-between space-y-6 hover:border-espresso/50 transition-colors">
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-sans text-2xl font-bold text-accent-brown tracking-tighter">04</span>
                    <i className="fa-solid fa-hourglass-half text-taupe text-sm" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">
                    Udvikling & Ro
                  </h4>
                  <p className="text-sm text-taupe leading-relaxed">
                    Efterfølgende følger du udviklingen og giver kroppen tid til processen
                  </p>
                </div>
                <div className="h-0.5 w-10 bg-accent-brown/30" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. FEDTFRYSNING MAVE, NÅR DU ØNSKER EN MÅLRETTET INDSATS */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start reveal-on-scroll">
            {/* Venstre kolonne: Fedtfrysning mave */}
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Fokuseret Område</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Fedtfrysning mave, når du ønsker en målrettet indsats
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Maven er et af de områder, hvor lokale fedtdepoter kan opleves som genstridige. Ved fedtfrysning mave tager vi udgangspunkt i fedtdepotets placering, områdets form og dine forventninger. Det gør det muligt at planlægge behandlingen ud fra din krop frem for at benytte den samme løsning til alle.
                </p>
                <p>
                  Ved konsultationen ser vi på det område, du ønsker behandlet, og taler med dig om et realistisk forløb. Fedtfrysning er bedst egnet til lokale fedtdepoter og er ikke beregnet som behandling af generel overvægt. Antallet af behandlinger og den forventede udvikling afhænger altid af dit udgangspunkt.
                </p>
              </div>

              <div className="pt-4 border-t border-taupe-border/60 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="p-4 bg-sand/60 border border-taupe-border/60 flex items-start gap-3">
                  <i className="fa-solid fa-crosshairs text-accent-brown mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <h5 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">Individuel tilpasning</h5>
                    <p className="text-xs text-taupe mt-1">Applikatorer placeres præcist efter dit fedtdepot</p>
                  </div>
                </div>
                <div className="p-4 bg-sand/60 border border-taupe-border/60 flex items-start gap-3">
                  <i className="fa-solid fa-compass text-accent-brown mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <h5 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">Realistisk forløb</h5>
                    <p className="text-xs text-taupe mt-1">Ingen standardløsninger eller urealistiske løfter</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Faktaboks */}
            <div className="lg:col-span-5 space-y-6">
              <div className="p-8 sm:p-10 bg-sand border border-taupe-border/90 space-y-6">
                <div className="inline-flex items-center gap-2 text-accent-brown text-xs font-bold uppercase tracking-wider">
                  <i className="fa-solid fa-circle-info" aria-hidden="true" />
                  <span>Kroppens Udgangspunkt</span>
                </div>
                <h4 className="font-sans text-xl sm:text-2xl font-semibold text-espresso uppercase tracking-wider leading-snug">
                  Målrettet lokale zoner
                </h4>
                <p className="text-sm sm:text-base text-taupe leading-relaxed">
                  Lokale fedtdepoter reagerer individuelt. Uanset om det gælder mave, flanker eller lår, tilpasses påsætningen altid dine kropslige proportioner og anatomi.
                </p>

                <div className="pt-4 border-t border-taupe-border/80 flex flex-col gap-3">
                  <div className="flex items-start gap-3 text-xs text-espresso">
                    <i className="fa-solid fa-circle-check text-accent-brown mt-0.5" aria-hidden="true" />
                    <span>Nøje afmålt placering af køleelementer</span>
                  </div>
                  <div className="flex items-start gap-3 text-xs text-espresso">
                    <i className="fa-solid fa-circle-check text-accent-brown mt-0.5" aria-hidden="true" />
                    <span>Ikke-invasiv behandling uden operationssår</span>
                  </div>
                  <div className="flex items-start gap-3 text-xs text-espresso">
                    <i className="fa-solid fa-circle-check text-accent-brown mt-0.5" aria-hidden="true" />
                    <span>Du kan vende direkte tilbage til hverdagen bagefter</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. ER FEDTFRYSNING DET RIGTIGE VALG FOR DIG (SUNDHED & EFTER BEHANDLING) */}
      <section className="py-20 lg:py-24 bg-warm-beige border-b border-taupe-border/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-10 reveal-on-scroll">
            {/* Header */}
            <div className="text-center space-y-3">
              <div className="inline-flex items-center justify-center gap-2 px-3 py-1 bg-sand border border-taupe-border text-accent-brown text-[11px] font-bold uppercase tracking-widest">
                <i className="fa-solid fa-shield-halved text-xs" aria-hidden="true" />
                <span>Tryghed & Forholdsregler</span>
              </div>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Er fedtfrysning det rigtige valg for dig
              </h3>
              <p className="text-sm sm:text-base text-taupe max-w-2xl mx-auto leading-relaxed">
                En grundig vurdering er vigtig, fordi behandlingen ikke passer til alle. Vi spørger ind til dit helbred og dine ønsker, før vi anbefaler et forløb. Har du sygdom, hudproblemer, graviditet eller særlig følsomhed over for kulde, skal du fortælle os det, så vi kan vurdere situationen på et oplyst grundlag.
              </p>
            </div>

            {/* Efter behandlingen boks */}
            <div className="p-8 sm:p-10 bg-cream border border-taupe-border/90 space-y-4 shadow-xs">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-sand border border-taupe-border flex items-center justify-center text-accent-brown">
                  <i className="fa-solid fa-notes-medical text-base" aria-hidden="true" />
                </div>
                <h4 className="font-sans text-base sm:text-lg font-semibold text-espresso uppercase tracking-wider">
                  Reaktioner efter behandlingen
                </h4>
              </div>
              <p className="text-sm sm:text-base text-taupe leading-relaxed">
                Efter behandlingen kan området i en periode føles ømt, køligt eller mindre følsomt, og huden kan blive rød. Reaktionen varierer fra person til person og aftager normalt gradvist. Vi gennemgår, hvad du kan forvente, så du føler dig godt informeret både før og efter din behandling hos os.
              </p>
            </div>

            {/* Forholdsregler faktaboks */}
            <div className="p-6 bg-sand-light border-l-4 border-accent-brown text-taupe text-xs sm:text-sm leading-relaxed">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-circle-info text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                <p>
                  Fortæl os altid om sygdom, hudproblemer, graviditet eller kuldeoverfølsomhed ved konsultationen. Vi hjælper med at afklare forløbet, så du altid er i trygge hænder.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. FEDTFRYSNING FØR OG EFTER, SÅDAN VURDERER DU UDVIKLINGEN */}
      <section className="py-20 lg:py-28 bg-sand border-b border-taupe-border/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center reveal-on-scroll">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Dokumentation & Forventninger</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Fedtfrysning før og efter, sådan vurderer du udviklingen
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Ved fedtfrysning før og efter er tålmodighed vigtig, da forandringen ikke opstår fra den ene dag til den anden. Kroppen skal have tid til at håndtere de påvirkede fedtceller, og udviklingen viser sig derfor gradvist. Resultatet varierer efter område, kropsform, livsstil og kroppens naturlige reaktion.
                </p>
                <p>
                  Du kan med fordel tage billeder før behandlingen og igen senere under samme lys og fra samme vinkel. Det giver et mere retvisende grundlag for at vurdere ændringen. Vi lover ikke et bestemt resultat, men hjælper dig med at sætte realistiske mål og følge udviklingen gennem dit behandlingsforløb.
                </p>
              </div>
            </div>

            {/* Praktiske fototips boks */}
            <div className="lg:col-span-5">
              <div className="p-8 sm:p-10 bg-cream border border-taupe-border space-y-6 shadow-xs">
                <h4 className="font-sans text-lg font-semibold text-espresso uppercase tracking-wider flex items-center gap-2.5">
                  <i className="fa-solid fa-camera text-accent-brown text-base" aria-hidden="true" />
                  <span>Tips til før & efter</span>
                </h4>
                <div className="space-y-4 text-xs sm:text-sm text-taupe">
                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-lightbulb text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                    <div>
                      <strong className="text-espresso block font-medium">Samme belysning</strong>
                      <span>Tag billederne i samme rum og ved samme dagslys eller lampelys.</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-arrows-to-dot text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                    <div>
                      <strong className="text-espresso block font-medium">Samme vinkel & afstand</strong>
                      <span>Hold kameraet i samme højde og vinkel (forfra, profil og skråt).</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="fa-solid fa-calendar-days text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                    <div>
                      <strong className="text-espresso block font-medium">Giv kroppen tid</strong>
                      <span>Kroppen udskiller gradvist de påvirkede celler over de følgende uger.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. FEDTFRYSNING TILBUD MED TYDELIGE VILKÅR & SAMMENLIGNING */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center reveal-on-scroll">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Gennemskuelighed</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Fedtfrysning tilbud med tydelige vilkår
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Et godt fedtfrysning tilbud handler ikke kun om den laveste pris. Du bør også vide, hvilket område behandlingen omfatter, hvad der indgår, og om din plan kræver mere end én behandling. Hos os får du information om forløbet, før du beslutter dig, så pris og forventninger hænger ordentligt sammen.
                </p>
                <p>
                  Du kan se{' '}
                  <Link to="/priser" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    aktuelle priser og eventuelle tilbud
                  </Link>
                  , når du booker tid online. Vil du først høre mere, er du altid velkommen til at{' '}
                  <Link to="/kontakt" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    kontakte os
                  </Link>
                  . Du kan også udforske vores øvrige kropsbehandlinger i Odense som{' '}
                  <Link to="/behandlinger/ems-traening" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    EMS træning
                  </Link>{' '}
                  eller{' '}
                  <Link to="/behandlinger/body-roll" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    Body Roll
                  </Link>{' '}
                  og finde den rette kombination til dig.
                </p>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/behandlinger/ems-traening"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-sand-light border border-espresso text-espresso text-xs font-semibold uppercase tracking-wider hover:bg-white transition-colors"
                >
                  <span>Læs om EMS træning</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <Link
                  to="/behandlinger/body-roll"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-sand-light border border-espresso text-espresso text-xs font-semibold uppercase tracking-wider hover:bg-white transition-colors"
                >
                  <span>Læs om Body Roll</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Handlingskort */}
            <div className="lg:col-span-5">
              <div className="p-8 sm:p-10 bg-sand border border-taupe-border space-y-6">
                <h4 className="font-sans text-lg font-semibold text-espresso uppercase tracking-wider">
                  Klar til at høre mere?
                </h4>
                <p className="text-xs sm:text-sm text-taupe leading-relaxed">
                  Hos Cryo By Breum på Dalumvej 82 i Odense SV står vi klar til at rådgive dig personligt om fedtfrysning og vores andre kropsbehandlinger.
                </p>

                <div className="pt-2 flex flex-col gap-3">
                  <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-accent-brown text-white text-xs uppercase tracking-widest font-semibold hover:bg-accent-brown-hover transition-colors shadow-xs"
                  >
                    <span>Se priser & ledige tider online</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
                  </a>
                  <Link
                    to="/kontakt"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-cream text-espresso text-xs uppercase tracking-widest font-semibold border border-espresso hover:bg-white transition-colors"
                  >
                    <span>Kontakt os med spørgsmål</span>
                    <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. AFSLUTTENDE BOOKING LINK */}
      <section className="py-16 bg-sand-light border-b border-taupe-border/60">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-5 reveal-on-scroll">
          <h3 className="font-sans text-xl sm:text-2xl font-semibold tracking-wider uppercase text-espresso">
            Klar til dit forløb med fedtfrysning?
          </h3>
          <p className="text-taupe text-sm sm:text-base max-w-xl mx-auto">
            Book din tid direkte på Planway eller udforsk vores priser nedenfor.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-brown text-white text-xs font-semibold uppercase tracking-widest hover:bg-accent-brown-hover transition-colors shadow-xs"
            >
              <span>Book tid online</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
            </a>
            <a
              href="#priser"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent text-espresso text-xs font-semibold uppercase tracking-widest border border-espresso hover:bg-cream transition-colors"
            >
              <span>Gå til prisoversigt</span>
              <i className="fa-solid fa-arrow-down text-xs" aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
